import { getApplePayAvailable } from "../common/getApplePayAvailable";
import { getGooglePayAvailable } from "../common/getGooglePayAvailable";
import { ApplePayPaymentMethod, GooglePayPaymentMethod } from "src/common/payment";
import { DevicePaymentBehavior } from "src/common/experience/interface";
import { initializeBraintreeApplePayButton } from "./initializeBraintreeApplePayButton";
import { initializeBraintreeGooglePayButton } from "./initializeBraintreeGooglePayButton";

export const applePayBehavior: DevicePaymentBehavior<ApplePayPaymentMethod> = {
    getAvailable: getApplePayAvailable,
    initializeButton: initializeBraintreeApplePayButton,
};

export const googlePayBehavior: DevicePaymentBehavior<GooglePayPaymentMethod> = {
    getAvailable: getGooglePayAvailable,
    initializeButton: initializeBraintreeGooglePayButton,
};
